import React, { useEffect, useState } from 'react';
import { toast } from 'react-toastify';
import httpRequest from 'src/helpers/httpRequest';
import PieChartGraph from 'src/Components/AdminComponents/Graphs/PieChartGraph';
import HomecareStates from 'src/Components/AdminComponents/HomecareStates';
import ProgressGraph from 'src/Components/AdminComponents/Graphs/ProgressGraph';
import SelectDropdown from 'src/Components/GlobalComponents/SelectDropdown';
import { CircularProgress } from '@mui/material';
import {
    BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer,
    LineChart,
    Line
} from 'recharts';
import { allMonths, allYears, CURRENCY } from 'src/lib/constans';
interface IData {
    count: number;
    _id: { year: number; month: number };
    totalAmount: number;
};

interface IOBJ {
    CategoryName: string;
    productCount: number;
};

interface ICateResponse {
    categoriesWithCounts: IOBJ[];
    totalCount: number;
};

const HomecareOverView: React.FC = () => {
    const [categoryLoader, setCategoryLoader] = useState<boolean>(false);
    const [homecareSelling, setHomecareSelling] = useState<{ loader: boolean; allCategories: any }>({
        loader: false,
        allCategories: [],
    });
    const [categoryData, setCategoryData] = useState<ICateResponse>({ categoriesWithCounts: [], totalCount: 0 }); // after api change
    const fetchCategoriesStats = async () => {
        setCategoryLoader(true);
        const { res, err } = await httpRequest<{ totalCount: number; result: { categoriesWithCounts: IOBJ[] } }>({ path: "/home-care-services/get-category-count" });
        if (res) {
            setCategoryData({ categoriesWithCounts: res?.result?.categoriesWithCounts || [], totalCount: res?.totalCount || 0 });
        } else {
            toast(err, { type: 'error' });
        }
        setCategoryLoader(false);
    };

const [salesLoader, setSalesLoader] = useState<boolean>(false);
    const [saleData, setSaleData] = useState<{
        category: "monthly" | "yearly";
        totalCount: number;
        monthlyData: IData[];
        yearlyData: IData[];
        data: { name: string; count: number; }[];
    }>({
        category: "monthly",
        totalCount: 0,
        monthlyData: [],
        yearlyData: [],
        data: [],
    });
    const fetchSaleRecord = async () => {
        setSalesLoader(true);
        const { res, err } = await httpRequest<{
            totalCount: { count: number }[];
            monthlyData: IData[];
            yearlyData: IData[];
        }[]>({ path: "/home-care-order/graph/statistics/sales" });
        if (res) {
            console.log(res,"------------------------------")
            setSaleData(prev => ({
                ...prev,
                totalCount: res[0]?.totalCount[0]?.count || 0,
                monthlyData: res[0]?.monthlyData,
                yearlyData: res[0]?.yearlyData,
            }));
        } else {
            toast(err, { type: "error" });
        }
        setSalesLoader(false);
    };

    const [revenueLoader, setRevenueLoader] = useState<boolean>(false);
    const [revenueData, setRevenueData] = useState<{
        category: "monthly" | "yearly";
        totalCount: number;
        monthlyData: IData[];
        yearlyData: IData[];
        data: { name: string; count: number; }[];
    }>({
        category: "monthly",
        totalCount: 0,
        monthlyData: [],
        yearlyData: [],
        data: [],
    });
    const fetchRevenueRecord = async () => {
        setRevenueLoader(true);
        const { res, err } = await httpRequest<{
            totalCount: { count: number }[];
            monthlyData: IData[];
            yearlyData: IData[];
        }[]>({ path: "/home-care-order/graph/statistics/revenue" });
        if (res) {
            setRevenueData(prev => ({
                ...prev,
                totalCount: res[0]?.totalCount[0]?.count || 0,
                monthlyData: res[0]?.monthlyData,
                yearlyData: res[0]?.yearlyData,
            }));
        } else {
            toast(err, { type: "error" });
        }
        setRevenueLoader(false);
    };

   

    const fetchTopSellingHomecareCategories = async () => {
        setHomecareSelling(prev => ({ ...prev, loader: true }));
        const { res, err } = await httpRequest<{ data: any }>({ path: "/home-care-order/top/selling-categories" });
        if (res) {
            setHomecareSelling(prev => ({ ...prev, allCategories: res?.data || [] }));
        } else {
            toast(err, { type: "error" });
        }
        setHomecareSelling(prev => ({ ...prev, loader: false }));
    };
    useEffect(() => {
        fetchCategoriesStats();
        fetchTopSellingHomecareCategories()
        fetchRevenueRecord()
        fetchSaleRecord()
    }, []);
     useEffect(() => {
            if (saleData?.category === 'monthly') {
                const formattedData = allMonths.map(({ month, name }) => {
                    const v = saleData?.monthlyData.find(v => v._id.month === month);
                    return {
                        name: name,
                        // count: v ? v.totalAmount : 0,
                        count: v ? v.count : 0,
                    };
                });
                setSaleData(prev => ({ ...prev, data: formattedData }));
            } else if (saleData?.category === 'yearly') {
                const formattedData = allYears.map(year => {
                    const v = saleData?.yearlyData.find(v => v._id.year === year);
                    return {
                        name: String(year), // year name
                        // count: v ? v?.totalAmount : 0,
                        count: v ? v?.count : 0,
                    };
                });
                setSaleData(prev => ({ ...prev, data: formattedData }));
            } else { }
        }, [saleData?.category, saleData?.totalCount]);
    
        useEffect(() => {
            if (revenueData?.category === 'monthly') {
                const formattedData = allMonths.map(({ month, name }) => {
                    const v = revenueData?.monthlyData.find(v => v._id.month === month);
                    return {
                        name: name,
                        count: v ? v.totalAmount : 0,
                    };
                });
                setRevenueData(prev => ({ ...prev, data: formattedData }));
            } else if (revenueData?.category === 'yearly') {
                const formattedData = allYears.map(year => {
                    const v = revenueData?.yearlyData.find(v => v._id.year === year);
                    return {
                        name: String(year), // year name
                        count: v ? v?.totalAmount : 0,
                    };
                });
                setRevenueData(prev => ({ ...prev, data: formattedData }));
            } else { }
        }, [revenueData?.category, revenueData?.totalCount]);
    return (
        <div className='gap-marging-admin'>
            <HomecareStates />
            <div className="parent-box parent-box-graph-height">

                <div className='grid grid-cols-1 md:grid-cols-2 gap-3'>

                <div>
                        <h2 className="font-Poppins-SemiBold text-[#232323] font-size-20px mb-2">Sales</h2>
                        <div className='user-graph-inner'>
                            <div className='flex justify-between items-center'>
                                <div className='font-Poppins-Regular user-graph-header font-size-14px whitespace-nowrap w-auto'>
                                    Total Sale: <span className='font-Poppins-SemiBold theme-color-green font-size-20px pl-1'>{saleData?.totalCount || 0}</span>
                                </div>
                                <div className='select-container-graph select-dropdown-container-graps w-auto'>
                                    <SelectDropdown
                                        options={[{ label: "Monthly", value: "monthly" }, { label: "Yearly", value: "yearly" }]}
                                        isMulti={false}
                                        data={[{ label: saleData?.category, value: saleData?.category }]}
                                        setData={(e) => setSaleData(prev => ({ ...prev, category: e[0]?.value }))}
                                        checkboxShow={false}
                                        isLabel={false}
                                        isRequired={true}
                                        clearIcon={false}
                                    />
                                </div>
                            </div>
                            {salesLoader
                                &&
                                <div className="text-center">
                                    <CircularProgress size={20} style={{ color: "#004540" }} />
                                </div>
                            }
                            <ResponsiveContainer className={'user-graph-container'}>
                                <BarChart
                                    data={saleData?.data}
                                    margin={{ top: 20, right: 0, left: -30, bottom: 0 }}
                                    barCategoryGap="15%"
                                >
                                    <CartesianGrid />
                                    <XAxis className='revenue-axis' dataKey="name" />
                                    <YAxis className='revenue-axis' />
                                    <Tooltip wrapperClassName='revenue-axis' />
                                    <Bar dataKey="count" fill="#00443F" radius={[10, 10, 0, 0]} />
                                </BarChart>
                            </ResponsiveContainer>
                        </div>
                    </div>
                    <div>
                        <h2 className="font-Poppins-SemiBold text-[#232323] font-size-20px mb-2">Revenue</h2>
                        <div className='user-graph-inner'>
                            <div className='flex justify-between items-center'>
                                <div className='font-Poppins-Regular user-graph-header-revenue user-graph-header font-size-14px whitespace-nowrap w-auto'>
                                    Total revenue: <span className='font-Poppins-SemiBold theme-color-green font-size-20px pl-1'>{CURRENCY} {revenueData?.totalCount?.toFixed(2) || 0}</span>
                                </div>
                                <div className='select-container-graph select-dropdown-container-graps w-auto'>
                                    <SelectDropdown
                                        options={[{ label: "Monthly", value: "monthly" }, { label: "Yearly", value: "yearly" }]}
                                        isMulti={false}
                                        data={[{ label: revenueData?.category, value: revenueData?.category }]}
                                        setData={(e) => setRevenueData(prev => ({ ...prev, category: e[0]?.value }))}
                                        checkboxShow={false}
                                        isLabel={false}
                                        isRequired={true}
                                        clearIcon={false}
                                    />
                                </div>
                            </div>
                            {revenueLoader &&
                                <div className="text-center">
                                    <CircularProgress size={20} style={{ color: "#004540" }} />
                                </div>
                            }
                            <ResponsiveContainer className={'user-graph-container'}>
                                <LineChart data={revenueData?.data} margin={{ top: 20, right: 0, left: 0, bottom: 0 }}>
                                    <CartesianGrid />
                                    <XAxis className='revenue-axis' dataKey="name" />
                                    <YAxis className='revenue-axis' tickFormatter={(value) => `${value}`} />
                                    <Tooltip wrapperClassName='revenue-axis' />
                                    <Line
                                        type="monotone"
                                        dataKey="count"
                                        stroke="#008A80"
                                        dot={{ r: 5 }}
                                        activeDot={{ r: 7 }}
                                    />
                                </LineChart>
                            </ResponsiveContainer>
                        </div>
                    </div>
                    <ProgressGraph
                        data={homecareSelling.allCategories?.slice(0, 5)?.map((v: any) => ({ label: v?.name, count: v?.totalCount }))}
                        totalCount={homecareSelling.allCategories?.slice(0, 5)?.reduce((prev: any, current: any) => { return prev + current?.totalCount }, 0)}
                        loader={homecareSelling.loader}
                        heading={"Top Selling Homecare Categories"}
                    />
                    <PieChartGraph
                        data={categoryData?.categoriesWithCounts?.map(v => ({ label: v?.CategoryName || "", count: v?.productCount || 0 }))}
                        totalCount={categoryData?.totalCount || 0}
                        loader={categoryLoader}
                        circleTitle={"Services"}
                        heading={"At-home Categories"}
                    />
                </div>
            </div>
        </div>
    );
};

export default HomecareOverView;